import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledWalletNightlyUpgradeAwardsSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};
  border-top: ${toRem(1)} solid #e8e8e8;

  .wallet-nightly-upgrade-awards-section__heading-row {
    display: flex;
    align-items: center;
    gap: ${toRem(8)};
  }

  .wallet-nightly-upgrade-awards-section__heading {
    color: ${baseVariables.color['base10']};
    font-size: ${toRem(18)};
    font-weight: ${baseVariables.font.fontWeightMedium};
    line-height: 1.25;
  }

  .wallet-nightly-upgrade-awards-section__count {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: ${toRem(24)};
    min-height: ${toRem(24)};
    aspect-ratio: 1;
    padding: 0 ${toRem(8)};
    border-radius: ${toRem(100)};
    background: ${baseVariables.color['base10']};
    color: #ffffff;
    font-size: ${toRem(12)};
    font-weight: ${baseVariables.font.fontWeightMedium};
    line-height: 1;
    box-sizing: border-box;
  }

  .wallet-nightly-upgrade-awards-section__empty-state {
    border: ${toRem(1)} dashed ${baseVariables.color['neutral30']};
    border-radius: ${toRem(14)};
    background: transparent;
    padding: ${toRem(24)};
    display: flex;
    align-items: center;
    gap: ${toRem(16)};
  }

  .wallet-nightly-upgrade-awards-section__empty-media {
    width: ${toRem(72)};
    height: ${toRem(52)};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .wallet-nightly-upgrade-awards-section__empty-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .wallet-nightly-upgrade-awards-section__empty-text {
    display: flex;
    flex: 1 0 0;
    min-width: 0;
    flex-direction: column;
  }

  .wallet-nightly-upgrade-awards-section__empty-message {
    color: ${baseVariables.color['neutral40']};
  }

  .wallet-nightly-upgrade-awards-section__empty-cta {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: ${toRem(4)};
    white-space: nowrap;
    cursor: pointer;
  }

  .wallet-nightly-upgrade-awards-section__empty-cta-link {
    font-size: ${toRem(13)};
    color: ${baseVariables.color['base10']};
    font-weight: ${baseVariables.font.fontWeightMedium};
  }

  .wallet-nightly-upgrade-awards-section__empty-cta .icon-forward-arrow {
    font-size: ${toRem(12)};
    color: ${baseVariables.color['base10']};
  }

  .wallet-nightly-upgrade-awards-section__description {
    font-size: ${toRem(14)};
    line-height: 1.5;
    color: ${baseVariables.color['base10']};
  }

  .wallet-nightly-upgrade-awards-section__description-link {
    font-size: ${toRem(14)};
    color: ${baseVariables.color['base10']};
    text-decoration: underline;
    text-underline-offset: ${toRem(3)};
  }

  .wallet-nightly-upgrade-awards-section__tiles {
    display: grid;
    grid-template-columns: 1fr;
    gap: ${toRem(16)};
  }

  @media ${baseVariables.mediaQuery.md} {
    .wallet-nightly-upgrade-awards-section__tiles {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media screen and (max-width: ${toRem(767)}) {
    .wallet-nightly-upgrade-awards-section__empty-state {
      flex-direction: column;
      align-items: flex-start;
      gap: ${toRem(12)};
      padding: ${toRem(16)};
    }

    .wallet-nightly-upgrade-awards-section__empty-cta {
      margin-left: 0 !important;
    }
  }
`;
